import React, { useState, useEffect } from "react"
import { useParams, Link } from "react-router-dom"
import Loader from "../Loader"

// custom hook
import useGetPlots from "../../hooks/useGetPlot"

export default function StateDonutEmbed() {
  const { id } = useParams()
  const [windowWidth, setWindowWidth] = useState(window.innerWidth || null)
  const [viewPort, setViewPort] = useState(null)

  useEffect(() => {
    window &&
      window.addEventListener("resize", () => setWindowWidth(window.innerWidth))
    if (windowWidth >= 320) {
      setViewPort("small")
    }
    if (windowWidth >= 780) {
      setViewPort("medium")
    }
    if (windowWidth >= 1024) {
      setViewPort("large")
    }
  }, [windowWidth])

  const [err, loading, displayPlot, usStateData] = useGetPlots(
    "state",
    viewPort,
    id
  )

  if (loading) return <Loader />

  return (
    <div className="page-state">
      <div className="container">{displayPlot("donut")}</div>
    </div>
  )
}
